import React, { useCallback, useEffect, useState } from "react";
import VideoFooter from "./VideoFooter";
import VideoSidebar from "./VideoSidebar";
import ReactPlayer from "react-player";
import "../css/Video.css";

export default function Video({
  url,
  band,
  venue,
  timestamp,
  cost,
  page,
  index,
  scrollDir,
  item,
  onScrollUp,
  onScrollDown,
  ticketURL,
  isActive = true,
}) {
  const [playing, setPlaying] = useState(false);
  const [liked, setLiked] = useState(false);

  const playerRef = React.useRef();

  // Memory optimization: tiered loading — only the visible video gets a full YouTube iframe
  const distanceFromCurrent = Math.abs(page - index);
  const isCurrentVideo = page === index;
  const isInActiveZone = distanceFromCurrent <= 1;
  const isInLightZone = distanceFromCurrent >= 2 && distanceFromCurrent <= 5;
  const shouldMountPlayer = isInActiveZone || isInLightZone;
  const useLightMode = shouldMountPlayer && !isCurrentVideo;
  
  // Only block iframe during active scrolling
  const isScrolling = scrollDir === 'up' || scrollDir === 'down';

  useEffect(() => {
    const shouldPause = !isCurrentVideo;
    // Pause only when this card is off-screen; scroll overlay handles scroll gestures
    if (shouldPause) {
      setPlaying(false);
    }
    return () => {
      if (shouldPause) {
        setPlaying(false);
      }
    };
  }, [index, page, isCurrentVideo]);

  const checkFav = useCallback(async () => {
    let vidos = await localStorage.getItem("fav");
    if (vidos !== null) {
      let parsVidos = JSON.parse(vidos);
      if (parsVidos?.length) {
        let ar = parsVidos.find((E) => E.id === item.id);
        if (ar) {
          setLiked(true);
        }
      }
    }
  }, [item.id]);

  useEffect(() => {
    checkFav();
  }, [checkFav]);

  const onSave = async () => {
    setLiked(true);
    let vidos = await localStorage.getItem("fav");
    if (vidos !== null) {
      let parsVidos = JSON.parse(vidos);
      if (parsVidos?.length) {
        let ar = [...parsVidos, item];
        await localStorage.setItem("fav", JSON.stringify(ar));
      } else {
        await localStorage.setItem("fav", JSON.stringify([item]));
      }
    } else {
      await localStorage.setItem("fav", JSON.stringify([item]));
    }
    window.dispatchEvent(new CustomEvent("favVideosUpdated"));
  };

  const onUnSave = async () => {
    setLiked(false);
    let vidos = await localStorage.getItem("fav");
    if (vidos !== null) {
      let parsVidos = JSON.parse(vidos);
      if (parsVidos?.length) {
        let ar = parsVidos.filter((e) => e.id !== item.id);
        await localStorage.setItem("fav", JSON.stringify(ar));
      }
    }
    window.dispatchEvent(new CustomEvent("favVideosUpdated"));
  };
  
  return (
    <div className="video" page={page}>
          {shouldMountPlayer ? (
            <div style={{ position: 'relative', width: '100%', height: '80%' }}>
              <ReactPlayer
                ref={playerRef}
                url={"https://www.youtube.com/watch?v=" + url}
                width="100%"
                height="100%"
                light={useLightMode ? `https://img.youtube.com/vi/${url}/maxresdefault.jpg` : false}
                onPlay={() => setPlaying(true)}
                onPause={() => setPlaying(false)}
                controls={true}
                key={`${url}-${isCurrentVideo ? 'active' : 'preload'}`}
                playing={playing}
                muted={false}
                playsinline={true}
                config={{
                  youtube: {
                    playerVars: {
                      playsinline: 1,
                      modestbranding: 1,
                      controls: 1,
                    }
                  }
                }}
              />
              {/* SCROLL BLOCKING ONLY - Top 60% only, leaves bottom 40% free for scrub bar */}
              {isActive && isScrolling && (
                <div 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: '40%', // CRITICAL: Leave bottom 40% completely free
                    zIndex: 4,
                    pointerEvents: 'auto',
                    touchAction: 'pan-y pinch-zoom', // Allow vertical scroll
                    backgroundColor: 'transparent'
                  }}
                />
              )}
            </div>
          ) : (
            <div style={{ 
              width: '100%', 
              height: '80%', 
              backgroundColor: '#000',
              backgroundImage: `url(https://img.youtube.com/vi/${url}/maxresdefault.jpg)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }} />
          )}
      <VideoFooter
        band={band}
        venue={venue}
        timestamp={timestamp}
        cost={cost}
        ticketURL={ticketURL}
      />
      <VideoSidebar
        onSave={onSave}
        onUnSave={onUnSave}
        liked={liked}
        messages={0}
        shares={0}
        item={{ url, band, venue, id: item?.id }}
      />
    </div>
  );
}
